import {
  IsString, IsNumber, IsNotEmpty, IsEmail, Matches,
} from 'class-validator';

export class CreateUserRequestDTO {
  @IsString()
  @IsNotEmpty()
  public name!: string;

  @IsString()
  @IsNotEmpty()
  public firstname!: string;

  @IsString()
  @IsNotEmpty()
  public lastname!: string;

  @IsEmail()
  public email!: string;

  @IsString()
  @IsNotEmpty()
  public tenant!: string;

  @IsNumber()
  @IsNotEmpty()
  public role_id!: number;

  @Matches(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
    { message: 'min 8 characters, min 1 upper/lower/number/spec-char' })
  public password?: string;

  public group_code?: string | null;

  public timeZone?: string | null;

  public facility?: string | null;
}

export interface ICreateUserResponse {
  id: number;
}
